export default __webpack_public_path__ + "static/media/mercado.a7a1add8.png";